export default "/packs/images/person-sharp~6899d4f617f14cda16c88d9214416084.svg";